export interface ILatestRequestGuard {
  begin: () => number;
  invalidate: () => void;
  isLatest: (requestId: number) => boolean;
}

export const createLatestRequestGuard = (): ILatestRequestGuard => {
  let latestRequestId = 0;

  return {
    begin: () => ++latestRequestId,
    invalidate: () => {
      latestRequestId += 1;
    },
    isLatest: requestId => requestId === latestRequestId,
  };
};
